import { CheckCircle, XCircle, AlertCircle, Info } from 'lucide-react';
import { cn } from './cn';
import { STATUS, R, type StatusVariant } from './tokens';

const ICONS: Record<StatusVariant, React.ElementType> = {
  success: CheckCircle,
  error:   XCircle,
  warning: AlertCircle,
  info:    Info,
  neutral: Info,
};

interface AlertProps {
  variant?: StatusVariant;
  className?: string;
  children?: React.ReactNode;
}

export function Alert({ variant = 'error', className, children }: AlertProps) {
  const token = STATUS[variant];
  const Icon = ICONS[variant];

  return (
    <div
      className={cn(
        'flex items-start gap-3 p-4 text-sm border',
        R.base,
        token.bg,
        token.border,
        token.text,
        className,
      )}
    >
      <Icon size={18} className={cn('shrink-0 mt-0.5', token.icon)} />
      <div>{children}</div>
    </div>
  );
}
